<div class="home">
  <div class="header">
    <div class="inside">
      <div id="logo"><img ngSrc="./assets/logo.jpg" alt="DRIVOSOL® Tuner" height="225" width="553"></div>
      <div id="evonik_logo"><img ngSrc="./assets/evonik_logo.png" alt="Evonik" height="76" width="294"></div>
    </div>
  </div>
  <div class="section">
    <div class="inside">
      <div class="infotext" (click)="openInfo($event)"><svg class="icon"><use xlink:href="#icon-info"></use></svg></div>
      <h1>Create your own <span class="trade">DRIVOSOL</span></h1>
      <div class="cols">
        <div class="col-50">
          <a routerLink="/mixing" i18n-routerLink="/pressure@@link_mixing" class="icon-teaser">
            <figure><svg class="icon"><use xlink:href="#icon-mixing"></use></svg></figure>
            <div class="label" i18n="@@mixing-tile">Nach Mischung</div>
          </a>
        </div>
        <div class="col-50">
          <a routerLink="/pressure" i18n-routerLink="/pressure@@link_pressure" class="icon-teaser">
            <figure><svg class="icon"><use xlink:href="#icon-pressure"></use></svg></figure>
            <div class="label" i18n="@@pressure-tile">Nach Druck</div>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
